//
import Model from "@/models/Model"

//
import ConfirmModel from "@/models/Actions/AConfirm"
import TakeModel from "@/models/Actions/ATake"
import DetailInventoryModel from "@/models/Warehouse/WhDetailInventory"
import InventoryCancelledModel from "@/models/Warehouse/WhInventoryCancelled"

/**
 * 
 */
export default class WhInventory extends Model {

    //
    flag_replace = true
    wh_selected_products = []

    //
    static includes = [
        "g_state",
        "g_user_supervisor.hr_employee",
        "g_user_warehouseman.hr_employee",
        "wh_detail_inventories.wh_product",
        "wh_stock_adjust",
        "wh_warehouse",
    ]

    /**
     * 
     */
    get can_confirm () {
        return this.g_state_id === 15
    }

    /**
     * 
     */
    get cannot_confirm () {
        return this.can_confirm !== true
    }
    
    /**
     * 
     */
    get can_take () {
        return this.g_state_id < 16
    }

    /**
     * 
     */
    get cannot_take () {
        return this.can_take !== true
    }

    /**
     * Fetches a skeleton excel.
     *
     * @return     {<type>}  The skeleton excel.
     */
    fetchSkeletonExcel = () => {
        return this.fetchBlob('squeleton_excel').then(this.showFile('skeleton_excel', 'xlsx'))
    }

    /**
     * 
     */
    get g_state_state () {
        return this.g_state.state
    }

    /**
     * 
     */
    get g_user_id () {
        return this.user ? this.user.id : 0
    }
    
    /**
     * 
     */
    get g_user_supervisor_name () {

        //
        if ( this.g_user_supervisor ) {

            //
            return [
                this.g_user_supervisor.hr_employee.names,
                this.g_user_supervisor.hr_employee.last_name1,
                this.g_user_supervisor.hr_employee.last_name2,
            ].join(" ")            
        }

        //
        return "-"
    }

    /**
     * 
     */
    get g_user_warehouseman_name () {
        return [
            this.g_user_warehouseman.hr_employee.names,
            this.g_user_warehouseman.hr_employee.last_name1,
            this.g_user_warehouseman.hr_employee.last_name2,
        ].join(" ")
    }
    
    /**
     * 
     */
    get wh_detail_inventories_length () {
        return this.wh_detail_inventories.length
    }
    
    /**
     * 
     */
    get wh_warehouse_name () {
        return this.wh_warehouse.name
    }
    
    /**
     * 
     */
    get wh_warehouse_g_branch_office_id () {
        return this.wh_warehouse.g_branch_office_id
    }

    /**
     * 
     */
    cancelled () {
        return new InventoryCancelledModel({ inventory_id: this.id, observation: "cancelación de inventario" }).save()
    }

    /**
     * 
     */
    confirm () {
        return this.hasMany( ConfirmModel ).sync({
            wh_detail_inventory: this.wh_detail_inventories.map( this.mapSelected ).map( this.mapTake ) 
        })
    }

    /**
     * 
     */
    mapDetail ( item ) {
        return {
            wh_product_id: Number( item.id ),
        }
    }
    
    /**
     * 
     */
    mapSelected = item => {
        return new DetailInventoryModel({
            ...item,
            ...item.wh_product,
            stock: item.stock || item.expected_amount || 0,
            amount_found_new: item.amount_found,
            flag_replace: true,
        })
    }
    
    /**
     * 
     */
    mapTake ( item ) {
        return {
            wh_product_id   : Number( item.id ),
            amount_found    : Number( item.amount_found_edited ),
            expected_amount : Number( item.expected_amount ),
        }
    }

    /**
     * 
     */
    pdf () {
        return this.fetchPdf().then( this.parsePdf ).then( this.printPdf )
    }

    /**
     * 
     */
    fetchPdf (type) {
        return this.$http({
            url: [ this.fullURL(), "pdf" ].join("/") ,
            method: "GET",
            params: {
                horizontal: type === 'HORIZONTAL' ? 1 : 0,
            },
            responseType: "blob",
        })
    }

    /**
     * 
     */
    parsePdf ({ data }) {
        return new Blob([ data ], {
            type: "application/pdf"
        })
    }

    /**
     * 
     */
    printPdf ( pdf ) {
        return window.open( URL.createObjectURL(pdf) )
    }

    /**
     * 
     */
    reset () {

        //
        this.wh_selected_products = this.wh_detail_inventories ? this.wh_detail_inventories.map( this.mapSelected ) : []

        //
        return this
    }

    /**
     * 
     */
    resource () {
        return "wh_inventory"
    }

    /**
     * 
     */
    take () {
        return this.hasMany( TakeModel )
    }

    toggleDetailReplace = () => {
        this.wh_selected_products.forEach(item => {
            item.flag_replace = this.flag_replace
        })
    }

    /**
     * 
     */
    toCreate () {

        //
        this.wh_detail_inventory = this.wh_selected_products.map( this.mapDetail )

        //
        return this.clone().clean([
            "wh_warehouse_id",
            "description",
            "wh_detail_inventory",
        ])
    }

    /**
     *
     */
    toPdf({ type }) {
        return this.fetchPdf(type)
            .then(this.parsePdf)
            .then(this.printPdf)
    }

    
    /**
     * 
     */
    toTake () {

        //
        this.wh_detail_inventory = this.wh_selected_products.map( this.mapTake )

        //
        return this.clone().clean([
            "wh_detail_inventory",
        ])
    }

    /**
     * 
     */
    toUpdate () {

        //
        this.wh_detail_inventory = this.wh_selected_products.map( this.mapDetail )

        //
        return this.clone().clean([
            "description",
            "id",
            "wh_detail_inventory",
            "wh_warehouse_id",
        ])
    }
}